<!--test.vue-->
<template>
  <div class="Ds-image">
    <img draggable="false" :src="imageSrc" alt="" v-if="imageSrc">
    <img draggable="false" :src="randomImageSrc" alt="" v-else>
  </div>
</template>

<script>
	export default {
    name: 'DsImage',
    data() {
      return {
      }
    },
		props: {
			imageSrc: {
        type: String,
        default:'https://www.qmx.top/upload/2023/08/08/20230808112413008h619em6N.jpg'
      }
    },
    computed: {
    }
	}
</script>

<style lang="scss" scoped>
  .Ds-image{
    width: 100%;
    height: 100%;
    margin-top: -0.5px;
  }
  img{
    display: block;
    width: 100%;
    height: 100%;
    -webkit-user-drag: none;
  }
</style>
